import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { saveScanInOffline, syncScans } from "./dbService";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL

export const useGetCollection = (url) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [error, setError] = useState();

    const fetchData = useCallback( async () => {
        try {
            setLoading(true);
            const { data } = await axios.get(url);
            setData(data);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        };
    }, [url]);

    useEffect( () => {
        fetchData();
    }, [fetchData]);

    const refetch = async () => {
        fetchData()
    }

    return {
        loading,
        data,
        refetch,
        error
    }
}

export const useGetObject = (url) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    const [error, setError] = useState();

    const fetchData = useCallback( async () => {
        try {
            setLoading(true);
            const { data } = await axios.get(url);
            setData(data);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        };
    }, [url]);

    useEffect( () => {
        fetchData();
    }, [fetchData]);

    const refetch = async () => {
        fetchData()
    }

    return {
        loading,
        data,
        refetch,
        error
    }
}

export const postObject = async (url, postObject, apiKey, sync) => {
    try {
        const result = await axios.post(url, postObject, {
            headers: {
                'apiKey': apiKey,
            }
        });
        if (sync) syncScans();
        return result;
    } catch (error) {
        if (error.code === 'ERR_NETWORK') saveScanInOffline(postObject, url, apiKey);
        return error;
    }
}

export const deleteObject = async (url, apiKey) => {
    try {
        const result = await axios.delete(url, {
            headers: {
                'apiKey': apiKey
            }
        });
        return result;
    } catch (error) {
        return error;
    }
};